import { ListPagination } from "@/components/ListPagination";

interface ProviderPaginationProps {
    page: number;
    total: number;
    pageSize: number;
    onPage: (page: number) => void;
    onPageSize?: (size: number) => void;
}

export const ProviderPagination = (props: ProviderPaginationProps) => (
    <ListPagination {...props} />
);
